const TableEntrySelector = ({ options, value, onChange, language }) => {
  return (
    <div className="flex items-center space-x-2">
      <span className="text-md">{language ? "दिखाएँ" : "Show"}</span>
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="border rounded px-3 py-2 text-sm"
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
      <span className="text-md">{language ? "रिकॉर्ड" : "Entries"}</span>
    </div>
  );
};

export default TableEntrySelector;
